import React, { Component } from 'react';
import { translate } from '../Services/translation';

class WishListOverview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editCurrentName: '',
            editNewName: '',
        };
    }

    updateEditWishlist(evt) {
        const val = evt.target.value;
        this.setState({
            editNewName: val,
        });
    }

    handleGoToList(listName) {
        this.props.onGoToList(listName);
        this.props.onUpdateActiveList(listName);
    }

    handleEditList(listName) {
        this.props.onEditList(listName);
        this.setState(() => ({
            edit: true,
            editCurrentName: listName,
            editNewName: listName,
        }));
    }

    handleUpdateWishlistName() {
        this.props.onUpdateWishlistName(
            this.state.editCurrentName,
            this.state.editNewName
        );
    }

    handleDeleteList(listName) {
        this.props.onDeleteList(listName);
    }

    handleAddWishlistName(evt) {
        const val = evt.target.value;
        this.setState({
            wishlistName: val,
        });
    }

    render() {
        const { wishList } = this.props;
        return (
            <div
                className="wishlist__content__lists__container"
                key={this.props.edit}
            >
                {this.props.wishList && Object.keys(wishList).length < 1 && (
                    <div className="wishlist__content__lists__container__empty">
                        <p>{translate('wishlist.nowishlist')}</p>
                    </div>
                )}
                {this.props.edit && (
                    <div className="wishlist__content__lists__container__edit">
                        <input
                            className="wishlist-add__form-input"
                            id="wishlist-name"
                            name="name"
                            type="text"
                            value={this.state.editNewName}
                            onChange={(evt) => this.updateEditWishlist(evt)}
                        />
                        <div className="wishlist__content__lists__container__edit__button-wrapper">
                            <button
                                type="submit"
                                className="button button--cancel"
                                onClick={() => {
                                    this.setState({
                                        edit: false,
                                    });
                                    this.handleDeleteList(
                                        this.state.editCurrentName
                                    );
                                }}
                            >
                                {translate('wishlist.delete')}
                            </button>
                            <button
                                type="submit"
                                className="button button--submit"
                                onClick={() => {
                                    this.handleUpdateWishlistName();
                                    this.setState({
                                        edit: false,
                                    });
                                }}
                            >
                                {translate('wishlist.save')}
                            </button>
                        </div>
                    </div>
                )}

                {!this.props.edit &&
                    this.props.wishList &&
                    this.props.wishList.map((item, index) => (
                        <div
                            key={`wishlist-overview-list-item-${index}`}
                            className="wishlist__content__lists__item"
                        >
                            <p className="wishlist__content__lists__item__text">
                                {item.name}
                            </p>
                            <div className="wishlist__content__lists__item__handle-list">
                                <a
                                    className="wishlist__content__lists__item__handle-list__edit"
                                    onClick={() =>
                                        this.handleEditList(item.name)
                                    }
                                    title={translate('edit')}
                                ></a>
                                <a
                                    className="wishlist__content__lists__item__handle-list__delete"
                                    onClick={() =>
                                        this.handleDeleteList(item.name)
                                    }
                                    title={translate('delete')}
                                ></a>
                            </div>
                            <a
                                className="wishlist__content__lists__item__chevron"
                                onClick={() => this.handleGoToList(item.name)}
                                title={translate('wishlist.gotolist')}
                            ></a>
                        </div>
                    ))}
            </div>
        );
    }
}

export default WishListOverview;
